module.exports = __webpack_public_path__ + "static/media/not_editing_icon.2d9b04dd.jpeg";